<template>
  <el-popover
    v-model="visible1"
    popper-class="input-number-pop"
    placement="top-start"
    :content="content"
    trigger="manual"
  >
    <el-input
      slot="reference"
      v-model="childValue"
      :class="['input-number', visible2 ? 'error-input' : '']"
      :size="size"
      :disabled="disabled"
      :placeholder="isPlaceholder"
      :maxlength="maxlength"
      clearable
      @input="inputAction"
      @focus="focusAction"
      @blur="blurAction"
      @keyup.native="tabCell"
      @clear="clear"
    />
  </el-popover>
</template>

<script>
// import { Format } from '@cndinfo/cube-web-utils'
// import { Validate } from '@cndinfo/cube-web-utils'
// import '../../../../lib/styles/components/InputNumber.scss'

export default {
  name: 'AgGridInput',
  props: {
    // 组件唯一标识
    mark: {
      type: String,
      default: ''
    },
    // 是否在ag-grid中使用
    forGrid: {
      type: Boolean,
      default: false
    },
    // 绑定值（v-model）
    value: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'amount'
    },
    placeholder: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'mini'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 保留几位小数(输入时限制)
    decimalDigit: {
      type: Number,
      default: null
    },
    // 输入值的范围
    range: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 是否展示千分符
    thousandthSign: {
      type: Boolean,
      default: false
    },
    // 是否可输入负值
    negative: {
      type: Boolean,
      default: false
    },
    // 只输入负值
    minus: {
      type: Boolean,
      default: false
    },
    // 是否自动聚焦
    autoFocus: {
      type: Boolean,
      default: false
    },
    // 聚焦是否选中内容
    focusSelect: {
      type: Boolean,
      default: false
    },
    // 当前行数据（ag-grid中使用必须有）
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 必填
    required: {
      type: Boolean,
      default: false
    },
    // 输入规则
    rules: {
      type: Array,
      default: () => {
        return [{ max: 19, min: 6 }]
      }
    },
    // 是否返回空
    returnNull: {
      type: Boolean,
      default: false
    },
    rule: {
      type: Function,
      default: null
    },
    max: {
      type: Number,
      default: 0
    },
    // 字段已存在 自定义文本
    msg: {
      type: String,
      default: '字段已存在'
    },
    cancelValue: {
      type: Boolean,
      default: true
    },
    maxlength: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      visible1: false,
      visible2: false,
      unformatValue: '',
      childValue: this.value,
      // 当前是否聚焦
      flagFocus: false,
      oldChildValue: this.value,
      content: this.msg
    }
  },
  computed: {
    isPlaceholder() {
      return this.placeholder || this.$t('components.pleaseEnter')
    }
  },
  watch: {
    value(nv, ov) {
      this.childValue = nv
    }
  },
  mounted() {
    if (this.params && Object.keys(this.params).length > 0) {
      this.childValue = this.params.value
    } // （ag-grid中使用必须有）
    // 返回当前组件指向
    this.mark && this.$emit('getComponent', this)
    this.$nextTick(() => {
      this.autoFocus && this.focus()
    })
  },
  // 销毁前触发失焦事件--解决ag-grid点击直接退出编辑状态情况
  beforeDestroy() {
    this.cancelValue && this.visible2 && (this.childValue = this.oldChildValue)
    console.log('----------7', this.childValue)
    const pseudoEvent = {
      mark: 'pseudoEvent',
      target: {
        value: this.childValue
      }
    }
    this.flagFocus && this.blurAction(pseudoEvent)
  },
  methods: {
    // 监听键盘事件
    tabCell(e) {
      if (!this.mark) return
      // 解决ag-grid编辑状态回车赋值以及计算问题
      // this.visible2 && (this.childValue = this.oldChildValue)
      console.log('----------8', this.childValue, this.visible2)
      if (e.keyCode === 13) {
        const pseudoEvent = {
          mark: 'pseudoEvent',
          target: {
            value: this.childValue
          }
        }
        this.flagFocus && this.blurAction(pseudoEvent)
      }
      this.$emit('keyup', e)
    },
    // 设置值方法
    setValue(value) {
      this.childValue = value
      this.visible2 && (this.childValue = this.oldChildValue)
      console.log('----------1', this.childValue)
      this.$emit('input', this.childValue)
      this.$emit('change', this.childValue)
      this.$emit('getVal', this.childValue) // （ag-grid中使用必须有）
    },
    focus() {
      this.$children[0].referenceElm.focus()
    },
    blur() {
      this.$children[0].referenceElm.blur()
    },
    select() {
      this.$refs.inputNumber.focus()
    },
    // 清空事件
    clear() {
      this.focus()
      this.$emit('clear', this.childValue)
      this.$emit('input', this.childValue)
      this.$emit('change', this.childValue)
      this.$emit('getVal', this.childValue) // （ag-grid中使用必须有）
    },
    // 聚焦事件
    focusAction(e) {
      if (this.visible2) this.visible1 = true
      // console.log('聚焦1--', e.target.value)
      // console.log('聚焦childValue--', this.childValue)
      this.flagFocus = true
      // if (this.childValue) {
      //   // 百分比转为数字
      //   if (this.type === 'percent') {
      //     // e.target.value = this.childValue = Format.toPoint(this.childValue)
      //     this.childValue = e.target.value = this.childValue.replace('%', '')
      //     // console.log('聚焦事件后--', this.childValue)
      //   } else if (this.type === 'amount' || this.thousandthSign) {
      //     // 货币格式（千分符）转为数字
      //     e.target.value = this.childValue = Format.toNum(this.childValue)
      //   }
      // }
      if (this.childValue) {
        e.target.value = this.visible2 ? this.oldChildValue : this.childValue
      }
      console.log('----------2', this.childValue)
      // this.visible2 && (this.childValue = this.oldChildValue)
      console.log('聚焦2--', e.target.value)
      if (this.focusSelect) {
        this.$nextTick(() => {
          e.target.select()
        })
      }
      this.$emit('focus', e)
    },
    // 输入事件
    inputAction(e) {
      if (this.rule && this.childValue) {
        this.rule(this.params, this.childValue)
          .then((res) => {
            this.content = this.msg
            if (res.data) {
              this.visible1 = this.visible2 = false
            } else {
              this.visible1 = this.visible2 = true
              // this.msg = '字段已存在'
            }
          })
          .catch((err) => {
            this.visible1 = this.visible2 = true

            this.content = err || this.msg
          })
      }
      if (this.max > 0) {
        this.childValue = this.childValue.substring(0, this.max)
      }
      this.setVal(e)
    },
    setVal(e) {
      this.cancelValue &&
        this.visible2 &&
        (this.childValue = this.oldChildValue)

      console.log('----------4', this.childValue)
      this.$emit('input', this.childValue)
      this.$emit('change', this.childValue, e)
      this.$emit('getVal', this.childValue) // （ag-grid中使用必须有）
    },
    // 失焦事件
    blurAction(e) {
      console.log('e.target.value', e.target.value)
      this.cancelValue &&
        this.visible2 &&
        (this.childValue = e.target.value = this.oldChildValue)
      console.log('---------5', this.childValue)
      // this.$emit('input', this.visible2 ? this.oldChildValue : this.childValue)
      // this.$emit('change', this.visible2 ? this.oldChildValue : this.childValue)
      // this.$emit('getVal', this.visible2 ? this.oldChildValue : this.childValue)
      this.$emit('input', this.childValue)
      this.$emit('change', this.childValue)
      this.$emit('getVal', this.childValue)
      this.$emit('blur', e)
      this.flagFocus = false
    }
  }
}
</script>
